import { modalIds } from "constants/modals-constants";
import { useModal } from "hooks/useModal";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Heading3 } from "styles/elements/Headings";
import { ParagraphLarge } from "styles/elements/Texts";
import { CssFlex } from "styles/helpers/layout";
import { StyledButton, StyledIntakeExamModal } from "./IntakeExamResultsModal.styled";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { TEST_PAGE_ROUTES } from "constants/routes";
import { useProductProgress } from "hooks/useProductProgress";

interface IntakeExamResultsModalProps {
  productId: number;
  moduleId: number;
}

export const IntakeExamResultsModal: React.FC<IntakeExamResultsModalProps> = ({
  productId,
  moduleId,
}) => {
  const { t } = useTranslation("modal");
  const navigate = useNavigate();
  const { isModalOpen, closeModal, modalParams } = useModal();
  const { initProgressFromIntakeTestResults } = useProductProgress();

  const { subjectId, subjectName } = modalParams || {};
  if (!subjectId) {
    return null;
  }
  const startSkillDeterminationTest = () => {
    navigate(
      buildUrlWithPathParams(TEST_PAGE_ROUTES.SKILL_DETERMINATION_TEST, {
        productId,
        moduleId,
        subjectId: +subjectId,
      }),
    );
    closeModal();
  };

  const handleUseIntakeExamResults = () => {
    initProgressFromIntakeTestResults(productId, moduleId, +subjectId);
    closeModal();
  };

  return (
    <StyledIntakeExamModal
      closeOnClickOutside
      dataCy={modalIds.intakeExamResultsModal}
      isOpen={isModalOpen(modalIds.intakeExamResultsModal)}
      onClose={closeModal}
    >
      <>
        <Heading3 data-cy="subject-title-intake-modal">{subjectName}</Heading3>
        <ParagraphLarge>
          {t(
            "intakeExamResultsModal.paragraph",
            "Je hebt de intake toets gemaakt. Op basis van je resultaten is jouw beginniveau vastgesteld op:",
          )}
        </ParagraphLarge>
        <ParagraphLarge>
          {t("intakeExamResultsModal.subtitle", "Would you like to do that?")}
        </ParagraphLarge>
        <CssFlex justifyContent={"space-between"} marginTop={"0.5rem"} gap={1}>
          <StyledButton
            variant="primary-outline"
            onClick={startSkillDeterminationTest}
            dataCy="use-skill-determination-button"
          >
            {t("intakeExamResultsModal.buttonStartSkillDeterminationTest", "No")}
          </StyledButton>
          <StyledButton
            variant="primary"
            onClick={handleUseIntakeExamResults}
            dataCy="use-intake-test-results-button"
          >
            {t("intakeExamResultsModal.useIntakeTestResults", "Ja, sync my progress")}
          </StyledButton>
        </CssFlex>
      </>
    </StyledIntakeExamModal>
  );
};
